export default __webpack_public_path__ + "static/media/previous-inactive.9eaaee83.svg";